import { render, staticRenderFns } from "./addHomeWorkModal.vue?vue&type=template&id=76c451d4&scoped=true"
import script from "./addHomeWorkModal.vue?vue&type=script&lang=js"
export * from "./addHomeWorkModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c451d4",
  null
  
)

export default component.exports